export default __webpack_public_path__ + "static/media/view3_month_age_sex.6309f1eb.csv";